import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class EditService {
  openEdit$ = new Subject<{
    column: string;
    id: number | string;
    additionalData: any;
  }>();

  closeEdit$ = new Subject<any>();

  openEdit(column: string, id: number | string, additionalData: any): void {
    this.openEdit$.next({ column, id, additionalData });
  }

  closeEditAll(): void {
    this.closeEdit$.next(true);
  }
}
